<template>
  <b-row class="margin-0 overflow-hidden">
    <b-col cols="12" class="padding-0">
      <Dropdown
        :title="$lang.determine_evidence_reference"
        :label="$lang.evidence_reference"
        :placeholder="$lang.evidence_reference"
        :value="form.evidenceSelected"
        name="evidenceSelected"
        id="evidenceSelected"
        :vuelidateObj="$v.form.evidenceSelected"
        :options="evidenceOptions"
        :loading="evidenceLoading"
        :asyncSearch="getEvidenceOptions"
        @input="input"
        @focus="resetValidation"
        @blur="checkValidation"
      />
    </b-col>
    <b-col cols="12" class="flex-end padding-0 margin-top-2">
      <Button
        contentClass="justify-content-center"
        variant="filled-complementary"
        :text="$lang.cancel"
        @click="close()"
      />
      <Button
        class="margin-right-8"
        contentClass="justify-content-center"
        variant="filled-primary"
        :text="$lang.submit"
        :loading="loading"
        @click="submit()"
      />
    </b-col>
  </b-row>
</template>

<script>
import inputMixin from "@/mixin/inputMixin.vue";
import { Dropdown, Button } from "@/components/re-design/forms";
import { required } from "vuelidate/lib/validators";
import { pathOr } from "ramda";
import { getEvidenceCombo } from "@/services";
import { referenceEvidence } from "@/modules/kanoon/services/evidence-services";

export default {
  mixins: [inputMixin],
  components: { Dropdown, Button },
  props: {
    itemId: {
      type: [String, Number],
      default: null,
    },
    item: {
      type: Object,
      default: null,
    },
  },
  validations() {
    return {
      form: {
        evidenceSelected: { required },
      },
    };
  },
  data() {
    return {
      form: {
        evidenceSelected: null,
      },
      evidenceOptions: [],
      evidenceLoading: false,
      loading: false,
    };
  },
  created() {
    this.getEvidenceOptions();
  },
  methods: {
    pathOr,
    close() {
      this.$emit("close");
    },
    async getEvidenceOptions(text = null) {
      try {
        this.evidenceLoading = true;
        const response = await getEvidenceCombo(text);
        const { options } = response;
        this.evidenceOptions = options.map((option) => {
          const { id = "", caption = "" } = option;
          return {
            ...option,
            caption: `${id}- ${caption}`,
          };
        });
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.evidenceLoading = false;
      }
    },
    async submit() {
      this.$v.$touch();
      if (this.$v.$anyError || this.loading) return;

      try {
        this.loading = true;
        const { evidenceSelected } = this.form;
        const referenceEvidenceId = pathOr(null, ["id"], evidenceSelected);

        if (referenceEvidenceId === this.itemId) {
          return this.$notify.warning(
            this.$lang.repeated_reference_evidence_message
          );
        }

        const response = await referenceEvidence(
          this.itemId,
          referenceEvidenceId
        );
        const { evidence, message } = response;

        this.$emit("getReferenceEvidence", this.item, evidence);
        this.$notify.success(message);
        this.close();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
